import hero from "./assets/osh_hero.jpg"

export const openScienceData = {
    title: "OScH in the Wild: Long-term Ethnographic Study on Open Science Hardware Movement",
    heroImage: hero,
    thumbnailImage:hero
}